import {
  MorphemePanelContent,
  MorphemeInfoPanelCaligraphyTab,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content";
import { useInfoWordMorphemeSliceQueryOptions } from "@-/dev.improve.haniverse.lib.morpheme.read";
import { usePrefetchedSuspenseQuery } from "@-/com.npmjs.tanstack__react-query";
import { MorphemeNotFound } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.not-found";

/** Renders the caligraphy content for a word reference. */
export function WordReferenceCaligraphyScreenSuspense({ word }: { word: string }) {
  const infoWordMorphemeSliceQueryOptions = useInfoWordMorphemeSliceQueryOptions(word);
  const { data: infoBackCardSlice } = usePrefetchedSuspenseQuery(infoWordMorphemeSliceQueryOptions);

  if (infoBackCardSlice === null) {
    return <MorphemeNotFound morpheme={word} />;
  }

  return (
    <MorphemePanelContent
      infoBackCardSlice={infoBackCardSlice}
      infoBackCardSliceQueryKey={infoWordMorphemeSliceQueryOptions.queryKey}
    >
      <MorphemeInfoPanelCaligraphyTab />
    </MorphemePanelContent>
  );
}
